import { baseColors } from "@Constants/baseStyles"
import * as React from "react"
import Svg, { Path } from "react-native-svg"

function SvgEscalade(props) {
    return (
        <Svg
            width={props.size ?? 20}
            height={props.size ?? 20}
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <Path
                d="M19.823 8.274L17.7 5.942c-.19-.21-.44-.357-.714-.425l-1.322-.323-1.569-1.453-.273-2.447a.669.669 0 10-1.33.149l.3 2.694c.02.16.094.308.211.417l2.28 2.112-.934 3.869-2.469-.06a1.002 1.002 0 00-.77.33L8.706 13.47a1.003 1.003 0 101.49 1.346l2.096-2.322 1.7.04-.998 1.426c-.153.219-.213.49-.166.753l.64 3.559a1.005 1.005 0 001.975-.355l-.565-3.147 1.834-2.617a.934.934 0 00.147-.307c.238-.952.922-3.814.922-3.814l.837.91-.404 2.428a.669.669 0 101.32.22l.458-2.752a.67.67 0 00-.168-.563z"
                fill={props.color ?? baseColors.green.primary}
            />
            <Path
                d="M16.346 4.89a1.542 1.542 0 101.729-2.553 1.542 1.542 0 00-1.73 2.553zM8.745 3.073L12.128.597a.237.237 0 00-.14-.428H1.06A1.06 1.06 0 000 1.229v18.268a.334.334 0 00.626.163l2.9-5.21a2.03 2.03 0 00.204-.53l1.002-4.34c.089-.386.289-.737.574-1.011l1.782-1.706c.307-.294.513-.676.592-1.094l.268-1.43c.094-.508.38-.961.797-1.266z"
                fill={props.color ?? baseColors.green.primary}
            />
        </Svg>
    )
}

export default SvgEscalade
